/**
 * @classdesc OS判定用のユーティリティクラス
 */
export default class OsUtils {

    /**
     * ユーザーエージェントからOS判定
     * @returns {string|null} 'android' | 'iOS' | null（非モバイル時）
     */
    static get getMobileOS() {
        const ua = navigator.userAgent;

        if (/Android/i.test(ua)) return 'android';
        if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';

        return null;
    }
}
